export const FETCH_BANK_SUCCESS = "FETCH_BANK_SUCCESS";
